import React, { memo } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Pickup } from '@interfaces/homepage';
import { ClickTarget, ContentType, TrackingLocation, click } from '@tracking';

interface ArticlePickupsProps {
  pickups: Pickup[];
}

const ArticlePickups = ({ pickups }: ArticlePickupsProps) => {
  const { Track, trackEvent } = useEventTracking({
    contentType: ContentType.Article,
    location: TrackingLocation.ArticlePickups,
  });

  return (
    <Track>
      <aside className="mt-64 border-0 border-b border-solid border-primary-magenta pb-32">
        <header className="border-0 border-b border-solid border-primary-magenta pb-8">
          <h3 className="my-0 font-suisse-intl-mono text-disclosure-lg text-primary-magenta sm:text-overline-lg">
            This article was later followed by
          </h3>
        </header>
        <ul className="!m-0 list-none p-0">
          {pickups.map(({ author, id, publication, title, url }) => (
            <li className="mt-32" key={url}>
              {publication && (
                <h4 className="m-0 font-suisse-intl text-overline-lg font-light text-black">
                  {publication}
                </h4>
              )}
              <a
                href={url}
                onClickCapture={() =>
                  trackEvent(
                    click({
                      clickTarget: ClickTarget.ArticlePickupTitle,
                      contentId: id,
                    })
                  )
                }
                target="_blank"
                className="mt-4 font-suisse-neue text-paragraph text-black sm:text-subheadline-sm"
                rel="noreferrer"
              >
                {title}
              </a>
              {author && (
                <span className="block font-suisse-screen text-byline-sm text-grayscale-gray sm:text-byline-md">
                  By {author}
                </span>
              )}
            </li>
          ))}
        </ul>
      </aside>
    </Track>
  );
};

export default memo(ArticlePickups);
